<template>
  <div v-if="modalVisible" class="app-modal">
    <div class="app-modal__dialog">
      <div
        class="app-modal__content"
        :class="{ 'app-modal__content--simple': modalIsOk && !modalTitle && !modalHeader }"
      >
        <div v-if="modalTitle" class="app-modal__header">
          <h5 class="app-modal__title">{{ modalTitle }}</h5>
        </div>
        <div v-else-if="modalIsOk && !modalHeader" class="app-modal__icon" aria-hidden="true">
          <i class="bi bi-exclamation-circle"></i>
        </div>
        <div class="app-modal__body">
          <p v-if="modalHeader" class="app-modal__header-text">{{ modalHeader }}</p>
          <p class="app-modal__message">{{ modalMessage }}</p>
          <p v-if="modalTextCustom" class="app-modal__link" @click="redirectPage">{{ modalTextCustom }}</p>
        </div>
        <div class="app-modal__actions" :class="{ 'app-modal__actions--single': !modalIsShowCancel }">
          <button type="button" class="app-modal__btn app-modal__btn--confirm" @click="handleConfirm">
            {{ modalIsOk ? getTranslatedText('ok') : modalTextButton }}
          </button>
          <button
            v-if="modalIsShowCancel"
            type="button"
            class="app-modal__btn app-modal__btn--cancel"
            @click="handleCancel"
          >
            {{ getTranslatedText('cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import { modal, modalState } from "@/composables/useModal";

export default {
  mixins: [languageMixins],
  props: {
    isVisible: { type: Boolean, default: undefined },
    message: { type: String, default: "" },
    title: { type: String },
    header: { type: String },
    textCustom: { type: String },
    textButton: { type: String },
    isShowCancel: { type: Boolean, required: false },
    isOk: { type: Boolean, required: false },
  },
  computed: {
    isGlobalModal() {
      return this.isVisible === undefined;
    },
    modalVisible() {
      return this.isGlobalModal ? modalState.isVisible : this.isVisible;
    },
    modalMessage() {
      return this.isGlobalModal ? modalState.message : this.message;
    },
    modalTitle() {
      return this.isGlobalModal ? modalState.title : this.title;
    },
    modalHeader() {
      return this.isGlobalModal ? modalState.header : this.header;
    },
    modalTextCustom() {
      return this.isGlobalModal ? modalState.textCustom : this.textCustom;
    },
    modalTextButton() {
      return this.isGlobalModal ? modalState.textButton : this.textButton;
    },
    modalIsShowCancel() {
      return this.isGlobalModal ? modalState.isShowCancel : this.isShowCancel;
    },
    modalIsOk() {
      return this.isGlobalModal ? modalState.isOk : this.isOk;
    },
  },
  methods: {
    handleConfirm() {
      if (this.isGlobalModal) {
        this.modalIsOk ? modal.confirm() : modal.custom();
        return;
      }
      this.$emit(this.modalIsOk ? "confirm" : "custom");
    },
    handleCancel() {
      if (this.isGlobalModal) {
        modal.close();
        return;
      }
      this.$emit("cancel");
    },
    redirectPage() {
      if (this.isGlobalModal) {
        modal.redirectPage();
        return;
      }
      this.$emit("redirectPage");
    },
  },
};
</script>

<style lang="scss">
@import "@/public/scss/components/common/modal.scss";
</style>
